import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCardLinkInternal, LazyCodeEditor, LazyEmbedBot, LazyAudioPlayer, LazyCatalogueTermTextReference, LazyCodeBlock, LazyColorBox, LazyExpandElement, LazyExternalLink, LazyFileDownloadBlock, LazyFileDownloadInline, LazyGeoGebraApplet, LazyGlossCollection, LazyGlossary, LazyHighlightedBox, LazyImageMagnifier, LazyMathFormula, LazyPronunciationBoxCollection, LazyReadMore, LazyRichTextCaptionAndCopyright, LazyRichTextImage, LazySentence, LazySourceInline, LazyTableWrapperElement, LazyTask, LazyTermExplanationButton, LazyVideoPlayer } from '#components'
const lazyGlobalComponents = [
  ["CardLinkInternal", LazyCardLinkInternal],
["CodeEditor", LazyCodeEditor],
["EmbedBot", LazyEmbedBot],
["AudioPlayer", LazyAudioPlayer],
["CatalogueTermTextReference", LazyCatalogueTermTextReference],
["CodeBlock", LazyCodeBlock],
["ColorBox", LazyColorBox],
["ExpandElement", LazyExpandElement],
["ExternalLink", LazyExternalLink],
["FileDownloadBlock", LazyFileDownloadBlock],
["FileDownloadInline", LazyFileDownloadInline],
["GeoGebraApplet", LazyGeoGebraApplet],
["GlossCollection", LazyGlossCollection],
["Glossary", LazyGlossary],
["HighlightedBox", LazyHighlightedBox],
["ImageMagnifier", LazyImageMagnifier],
["MathFormula", LazyMathFormula],
["PronunciationBoxCollection", LazyPronunciationBoxCollection],
["ReadMore", LazyReadMore],
["RichTextCaptionAndCopyright", LazyRichTextCaptionAndCopyright],
["RichTextImage", LazyRichTextImage],
["Sentence", LazySentence],
["SourceInline", LazySourceInline],
["TableWrapperElement", LazyTableWrapperElement],
["Task", LazyTask],
["TermExplanationButton", LazyTermExplanationButton],
["VideoPlayer", LazyVideoPlayer],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
